
import { defineComponent, PropType } from 'vue'
import { Paper } from '../types/incitefulTypes'
export default defineComponent({
  name: 'ExternalLinks',
  props: {
    paper: {} as PropType<Paper>
  }
})
